
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop-seller/[username]",
      function () {
        return require("private-next-pages/shop-seller/[username].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop-seller/[username]"])
      });
    }
  